module.exports = require("v-click-outside");